// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2njla","modalForm":"UpgradeEpcsModal_modalForm__27ndd","modalFooter":"UpgradeEpcsModal_modalFooter__378Qp"};